import React, { useState, useEffect, useRef } from 'react';
import '../styles/Card.css'; // Import your CSS file
import card0 from '../images/card0.png'
import card1 from '../images/card1.png'
import card2 from '../images/card2.png'
import card3 from '../images/card3.png'
import "../styles/responsive.css"

const Card = ({ title, content }) => {
  const [cardStates, setCardStates] = useState([
    { title: 'card0', isClicked: false, zd: '4', z: '5' },
    { title: 'card1', isClicked: false, zd: '3', z: '5' },
    { title: 'card2', isClicked: false, zd: '2', z: '5' },
    { title: 'card3', isClicked: false, zd: '1', z: '5' },
  ]);

  const handleClick = (index) => {
    setCardStates((prevCardStates) => {
      const newCardStates = prevCardStates.map((card, i) => {
        if (i === index) {
          return { ...card, isClicked: !card.isClicked }; // Toggle isClicked
        } else {
          return card;
        }
      });
      return newCardStates;
    });
  };
  
  const getImageSource = (title) => {
    switch (title) {
      case 'card0':
        return card0;
      case 'card1':
        return card1;
      case 'card2':
        return card2;
      case 'card3':
        return card3;
      default:
        return null;
    }
  };

  const getIndex = (title) => {
    switch (title) {
      case 'card0':
        return 0;
      case 'card1':
        return 1;
      case 'card2':
        return 2;
      case 'card3':
        return 3;
      default:
        return null;
    }
  };

  return (
    <div
      style={{ zIndex: cardStates[getIndex(title)].isClicked ? '5' : cardStates[getIndex(title)].zd }}
      className={`card ${cardStates[getIndex(title)].isClicked ? 'clicked' : ''}`}
      onClick={() => handleClick(getIndex(title))}
    >
      <img src={getImageSource(title)} alt="" />
      
    </div>
  );
};

export default Card;
